var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickOutlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6523 7.06666L7.85938 10.8596L6.56648 9.56666M8.85938 0.859558C4.4411 0.859558 0.859375 4.44128 0.859375 8.85956C0.859375 13.2778 4.4411 16.8596 8.85938 16.8596C13.2777 16.8596 16.8594 13.2778 16.8594 8.85956C16.8594 4.44128 13.2777 0.859558 8.85938 0.859558Z",
    stroke: "#7C7C7C",
    strokeOpacity: 0.780392,
    strokeWidth: 1.71908,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickOutlineIcon);
export default __webpack_public_path__ + "static/media/tick-outline-icon.bb4b19ba10d4ddd65a1a65c6c0f333b4.svg";
export { ForwardRef as ReactComponent };